import katex from 'katex';
import { memo, useMemo } from 'react';

const cache = new Map<string, string>();

/**
 * `\term{id}{body}` marks `body` as glossary term `id` by emitting a
 * `data-term` attribute on the rendered span. InteractiveMath turns those
 * spans into hover/click glossary affordances. Only author-written lesson TeX
 * uses it, so enabling KaTeX trust for the HTML extension is safe here.
 */
const MACROS = { '\\term': '\\htmlData{term=#1}{#2}' };

export function renderMath(tex: string, display: boolean, output: 'html' | 'htmlAndMathml' = 'htmlAndMathml'): string {
  const key = `${display ? 'D' : 'I'}:${output}:${tex}`;
  let html = cache.get(key);
  if (html === undefined) {
    html = katex.renderToString(tex, {
      displayMode: display,
      throwOnError: false,
      output,
      strict: false,
      macros: MACROS,
      trust: (ctx) => ctx.command === '\\htmlData' || ctx.command === '\\htmlClass',
    });
    cache.set(key, html);
  }
  return html;
}

export const MathTex = memo(function MathTex({ tex, display = false }: { tex: string; display?: boolean }) {
  const html = useMemo(() => renderMath(tex, display), [tex, display]);
  const Tag = display ? 'div' : 'span';
  return <Tag className={display ? 'math-block' : 'math-inline'} dangerouslySetInnerHTML={{ __html: html }} />;
});
